<template>
  <div
    class="relative my-0 flex w-full flex-col items-start rounded-md outline-none"
    @blur="open = false"
  >
    <label
      v-if="label"
      class="categoryParagraph"
      :for="label"
    >
      {{ label }}
    </label>
    <div
      class="flex w-full items-center justify-between rounded-md border border-transparent py-2 pl-4 text-sm text-body-color sm:text-base"
      :style="customStyle"
      :class="{
        open: open,
        [bgClass]: bgClass,
        'opacity-50': disabled,
        'cursor-pointer hover:border-placeholder-gray': !disabled,
      }"
      @click="toggleOpen"
    >
      <span
        v-if="selected"
        class="flex-grow text-left"
        :class="[lightText && !open ? 'text-white' : '']"
      >
        {{ parseInt(selected) > 0 ? '$' : '' }}{{ selected?.toLocaleString() }}
      </span>
      <span
        v-else-if="placeholder"
        class="flex-grow text-left"
        :class="[lightText && !open ? 'text-white' : '']"
      >
        {{ placeholder }}
      </span>
      <span
        v-else
        class="invisible flex-grow text-left"
      >
        {{ placeholder }}
      </span>
      <svg
        class="ml-1 mr-1 h-8 w-8 transition"
        :class="{ '-rotate-180 transform': open }"
        viewBox="0 0 27 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 13L13.5 19L19.5 13"
          :stroke="lightText && !open ? '#FFFFFF' : '#313545'"
          stroke-width="2"
        />
      </svg>
    </div>
    <div
      class="z-20 flex max-h-52 w-full flex-col items-start overflow-hidden overflow-y-scroll rounded-b-md border-b border-l border-r border-body-color bg-white py-2 sm:max-h-80"
      :class="{
        hidden: !open,
        'top-16': label,
        'top-12': !label,
        'dropdown-options': isFixed,
      }"
    >
      <div
        v-for="(option, i) of filterFor"
        :key="i"
        class="w-full cursor-pointer px-4 py-4 text-left hover:bg-lighter-gray hover:text-body-color"
        @click="
          selected = option.label;
          open = false;
          $emit('dropdownInput', option);
        "
      >
        <p
          class="text-gray-over-dark"
          :class="{ 'text-xs': excludeSelected }"
        >
          {{ option.label }}
        </p>
        <p
          v-if="option?.parragraph"
          class="text-xs text-gray-over-dark"
        >
          {{ option?.parragraph }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    options: {
      type: Array,
      required: true,
    },
    excludeSelected: {
      type: Boolean,
      default: false,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    label: String,
    bgClass: {
      type: String,
      required: false,
      default: 'bg-off-white',
    },
    lightText: {
      type: Boolean,
      required: false,
      default: false,
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
    isFixed: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: Boolean,
    placeholder: String,
  },
  data() {
    const initialOption =
      this.default !== undefined && this.default !== null
        ? this.options.find((option) => option.id === this.default)
        : this.options.length > 0
          ? this.placeholder
            ? null
            : this.options[0]
          : null;
    return {
      selected: initialOption?.label,
      open: false,
      fieldValue: this.field ? this.field : initialOption,
    };
  },
  computed: {
    filterFor: function () {
      if (this.excludeSelected) {
        return this.options.filter((option) => option.label !== this.selected);
      }

      return this.options.filter((el) => el !== this.selected);
    },
  },
  watch: {
    default: function (newValue) {
      const option =
        newValue !== undefined && newValue !== null
          ? this.options.find((option) => option.id === newValue)
          : this.options.length > 0
            ? this.placeholder
              ? null
              : this.options[0]
            : null;
      this.selected = option?.label;
      this.open = false;
    },
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown);
    if (this.placeholder) {
      return;
    }
    let fieldValue = this.fieldValue;
    let selected = this.selected;
    this.$emit('dropdownInput', fieldValue, selected);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdown);
  },
  methods: {
    closeDropdown(e) {
      if (!this.$el.contains(e.target)) {
        this.open = false;
      }
    },
    toggleOpen: function () {
      if (this.disabled) {
        return;
      }

      this.open = !this.open;
      if (this.open && this.isFixed) {
        const rect = this?.$el?.getBoundingClientRect();

        const top = rect?.bottom;
        const left = rect?.left;

        const dropdown = this.$el?.querySelector('.dropdown-options');
        dropdown.style.top = `${top}px`;
        dropdown.style.left = `${left}px`;
        dropdown.style.width = `${rect.width}px`;
      }
    },
  },
};
</script>
<style scoped>
.open {
  @apply rounded-b-none rounded-t-md border-l border-r border-t border-black;
  background: #fff !important;
}
.open:hover {
  @apply border-body-color;
}
.categoryParagraph {
  @apply mb-1 text-xxs font-bold uppercase text-dark-blue;
}

.dropdown-options {
  position: fixed;
  z-index: 1001;
}
</style>
